import {resolveMatchAjaxTabUrl} from "Core/mc/matches/match-ajax-tab-url-resolver";
import $ from 'jquery';
import axios from "axios";

export const processMatchTabItemClick = (elem) => {
    let ajaxBlock = $('.match-ajax-container');
    let matchBlock = $('.match-main-container');

    const tabUrl = resolveMatchAjaxTabUrl(elem.data('slug'));

    if (tabUrl === undefined) {
        processRegularTab(elem.data('slug'), ajaxBlock, matchBlock);

        return;
    }

    processAjaxTab(tabUrl, ajaxBlock, matchBlock);
};

const processRegularTab = (slug, ajaxBlock, matchBlock) => {
    ajaxBlock.hide();
    ajaxBlock.text('');
    matchBlock.show();

    const element = $(`#match-${slug}`);

    if (element.length > 0) {
        $('html,body').animate({scrollTop: element.offset().top}, 'slow');
    }
};

const processAjaxTab = (tabUrl, ajaxBlock, matchBlock) => {
    axios.get(tabUrl, {
        params: {
            matchId: $('.match-identifier').data('id')
        }
    })
        .then((response) => {
            ajaxBlock.html(response.data);
            matchBlock.hide();
            ajaxBlock.show();
        });
};
